
import { animate } from 'animejs';

class InitPage {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
      initBody();
    }

    let initCache = () => {
        cache.body = document.querySelector('body');
        cache.footer = document.querySelector('footer');
    };

    let registerEvents = () => {
        window.addEventListener('resize', initBody);
    };

    let initBody = () => {
        cache.body.style.marginBottom = cache.footer.offsetHeight + 'px';
    };

    initFunc();
  };
}
export { InitPage }
